import { render, staticRenderFns } from "./packageDetail.vue?vue&type=template&id=efeb82a0&scoped=true"
import script from "./packageDetail.vue?vue&type=script&lang=js"
export * from "./packageDetail.vue?vue&type=script&lang=js"
import style0 from "./packageDetail.vue?vue&type=style&index=0&id=efeb82a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeb82a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efeb82a0')) {
      api.createRecord('efeb82a0', component.options)
    } else {
      api.reload('efeb82a0', component.options)
    }
    module.hot.accept("./packageDetail.vue?vue&type=template&id=efeb82a0&scoped=true", function () {
      api.rerender('efeb82a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/franchiseeTimelinessStatistics/component/packageDetail.vue"
export default component.exports